import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { removeMessage } from '../../../../state/actions/core.actions';
import { Message } from '../../../../state/models/core.types';
import * as fromView from '../../../../state/selectors/view.selectors';

@Component({
    selector: 'app-messages',
    templateUrl: './messages.component.html',
    styleUrls: ['./messages.component.scss'],
    standalone: false,
})
export class MessagesComponent {
    private store = inject(Store);

    view$ = this.store.select(fromView.selectMessagesView);

    clearMessage(message: Message) {
        this.store.dispatch(removeMessage({ message }));
    }
}
